import { useState, useEffect, useContext } from 'react'
import { useQuery } from "@apollo/client";
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import {
    DYNOTYPES,
  } from "../../graphql/queries";

export const useCreateNewDyno = () => {
    const { user, publisher } = useContext(PublisherAndUserContext);
    const [selectedDynoType, setSelectedDynoType] = useState({});
    const [dynoTypes, setDynoTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    const { data: dynoTypesRes } = useQuery(DYNOTYPES);

    const selectDynoType = (dynoType) => {
        setSelectedDynoType(dynoType);
    };

    useEffect(() => {
        if (dynoTypesRes && dynoTypesRes.dynoTypes) {
            const order = {
                "Reading": 0,
                "Practice": 1,
                "Video": 2
            };
            setDynoTypes(dynoTypesRes.dynoTypes
                .filter(dt => ["Reading", "Practice", "Video"].includes(dt.name))
                .sort((a, b) => order[a.name] - order[b.name]));
            setSelectedDynoType(dynoTypesRes.dynoTypes
                .filter(dt => ["Reading", "Practice", "Video"].includes(dt.name))
                .sort((a, b) => order[a.name] - order[b.name])[0])
            setLoading(false)
        }
    }, [
        dynoTypesRes,
    ]);

    return {
        selectDynoType,
        dynoTypes,
        selectedDynoType,
        loading,
        user,
        publisher
    }
}

